import { render, staticRenderFns } from "./goodsGroup.vue?vue&type=template&id=b34c43c2&"
import script from "./goodsGroup.vue?vue&type=script&lang=js&"
export * from "./goodsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports